import { useFormContext } from 'react-hook-form';
import { INewCardFormData } from '../types/INewCardFormData';

export const useNewCardFormContext = () => useFormContext<INewCardFormData>();
